module.exports = __webpack_public_path__ + "img/6c9b8153e0cee1ea7dcaadf28302708d.0647f4e1.png";